/**
 * Open Banking `fetch` request payload builder.
 *
 * We pass the signed-in user’s partner flag along with Open Banking fetch requests so the backend
 * can store accounts as either Partner-owned (`"Y"`) or Customer-owned (`"N"`).
 *
 * Missing/invalid values default to `"N"` (safe fallback).
 */

export interface OpenBankingFetchRequest {
  customerId: number;
  searchId: string;
  isPartner: 'Y' | 'N';
}

const normalizePartnerFlag = (value: unknown): 'Y' | 'N' => {
  return String(value ?? 'N').trim().toUpperCase() === 'Y' ? 'Y' : 'N';
};

export function buildOpenBankingFetchPayload(
  customerId: number,
  searchId: string,
  isPartner: unknown
): OpenBankingFetchRequest {
  return {
    customerId,
    searchId,
    isPartner: normalizePartnerFlag(isPartner),
  };
}
